import { Container } from "@chakra-ui/react";
import { Footer, Navbar } from "../index";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export default function Layout({ children }: Props) {
  return (
    <div>
      <Navbar />
      <Container maxWidth="6xl" py="20px">
        {children}
      </Container>
      <Footer />
    </div>
  );
}
